// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:19:10

export default {
  "id": "merge-car-defense",
  "slug": "merge-car-defense",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1340302dda4c4bf9a8dcbd443baca0d9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1340302dda4c4bf9a8dcbd443baca0d9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Car Defense",
      "description": "Prepare to battle wave upon wave of relentless enemies as you skilfully merge and upgrade the defences of your cars.\n\nBuild out a roster of cars and use them tactically in order to defeat the enemy, collect coins and be victorious!",
      "instructions": "Use your mouse to swipe to upgrade the cars",
      "genres": [
        "Merge"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "合并汽车防御",
      "description": "准备与一波又一波凶猛的敌人战斗，同时你将巧妙地合并和升级你的车辆防御。\n\n组建一支车队，并战略性地使用它们来击败敌人、收集金币并取得胜利！",
      "instructions": "使用鼠标滑动来升级汽车",
      "genres": [
        "合并"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-TW": {
      "title": "合併車輛防禦",
      "description": "準備迎戰一波又一波的無情敵人，當你熟練地合並和升級車輛的防禦時。\n\n建立一隊車輛名單，並戰術性地使用它們以擊敗敵人、收集金幣並取得勝利！",
      "instructions": "使用滑鼠滑動來升級車輛",
      "genres": [
        "合併"
      ],
      "tags": [
        "1玩家"
      ]
    },
    "zh-HK": {
      "title": "合拼車輛防禦",
      "description": "準備與一波又一波的無情敵人作戰，當你靈巧地合併及升級車輛的防禦時。\n\n建立一隊車輛陣容，並戰術性地使用它們來擊敗敵人、收集硬幣並獲勝！",
      "instructions": "使用鼠標掃描以升級汽車",
      "genres": [
        "合併"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "合体車輛防衛",
      "description": "無情な敵の一波又一波と戦う準備をし、スキルフルに車の防衛を統合・強化していこう。\n\n車のリストを構築し、戦略的に使用して敵を倒し、コインを収集し、勝利を収めよう！",
      "instructions": "マウスを使ってスワイプして車をアップグレードしてください",
      "genres": [
        "合体"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "혼합차 방어",
      "description": "무慈悲한 적들의 물결에 맞서 차량의 방어력을 순수하게 통합하고 업그레이드하며 싸워보세요. 차량 명단을 구축하고 전략적으로 사용하여 적을 물리치고 동전을 모으고 승리하세요!",
      "instructions": "마우스로 드래그하여 차량을 업그레이드하세요",
      "genres": [
        "합성"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Défense de fusion de voitures",
      "description": "Préparez-vous à combattre vague après vague d'ennemis inébranlables tout en maîtrisant la fusion et l'amélioration des défenses de vos voitures.\n\nÉtablissez une liste de voitures et utilisez-les stratégiquement pour vaincre les ennemis, collecter des pièces et triompher !",
      "instructions": "Utilisez votre souris pour glisser pour améliorer les voitures",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
